import React from "react";
import { UsersManagement } from "../../components/UsersManagement";
import { useAuth } from "../../context/AuthContext";

export default function AdminUsers() {
  const { user } = useAuth();
  return (
    <div className="space-y-6">
      <div>
        <div className="text-[11px] font-medium tracking-widest uppercase text-text-muted mb-2">Amministrazione</div>
        <h1 className="text-3xl font-semibold text-text-primary tracking-tight">Utenti</h1>
        <p className="text-base text-text-secondary mt-2 max-w-xl">
          Gestisci gli accessi della tua organizzazione: crea operatori, assegna permessi, resetta password.
        </p>
      </div>
      <UsersManagement mode="admin-org" orgName={user?.org_id} />
    </div>
  );
}
